/*=========================================================================================
  File Name: moduleCompanyState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	resources: [],
	lastAddedResource: null,
	resourcesActivity: [],
	currentSelectedResource: null,
	categories: [],
	checkedResources: [],
	pagination: {
		next_page: 0,
		total_pages: 0,
		total_records: 0,
	},
	dataPage: {
		page: 1,
		quantity: 10,
	},
	availableResources: [],
	availableSelectedResources: [],
	markerResources: [],
	resourcesComunication: [],
	availableResourcesCurrentPayload: null,
};
